export const CHECK_USER_LOGGED_IN = "CHECK_USER_LOGGED_IN";
export const USER_LOGGED_IN_DETAILS = "USER_LOGGED_IN_DETAILS";
export const FETCH_USER_REQUEST = "FETCH_USER_REQUEST";
export const USER_TYPE = "USER_TYPE";
export const CART_DATA = "CART_DATA";
export const SEARCH_DATA = "SEARCH_DATA";